import styles from './requestMobile.module.css';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, Select, TextField, MenuItem } from "@mui/material";
import { Plus, UploadCloud, X } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";
import { useState } from "react";
import { useEffect } from "react";
import axios from 'axios';
import { AddLogCallAPI } from "../../../../components/AddLogs";
import { toast } from 'react-smart-toaster';
import dayjs from 'dayjs';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";

const RequestMobile = ({ isPanelOpen, onToggle, requestData, setRequestData, setLoading }) => {
  const { getAccessTokenSilently } = useAuth0();
  const { user, isAuthenticated } = useAuth0();
  const [descVal, setDescVal] = useState('');
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(0);
  const [deleteType, setDeleteType] = useState(0);
  const [selectedTechnician, setSelectedTechnician] = useState(0);
  const [technicianList, setTechnicianList] = useState([]);
  const [prevTechnician, setPrevTechnician] = useState(0);
  const [prevScDate, setPrevScDate] = useState(null);
  const [prevScTime, setPrevScTime] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState("");
  const [isReschedule, setIsReschedule] = useState(false);

  useEffect(() => {
    async function getAssigneeList() {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      axios.get(process.env.REACT_APP_CASE_API_URL + "v1/technicians-new", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((response) => {
        setTechnicianList(response.data.data);
      }).catch((error) => { });
    }
    getAssigneeList();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    if (requestData) {
      setDescVal(requestData?.description);
      setPrevTechnician(requestData?.technician_id);
      setSelectedTechnician(requestData?.technician_id);

      if (requestData?.schedule_date) {
        setPrevScDate(dayjs(requestData?.schedule_date));
        setSelectedDate(dayjs(requestData?.schedule_date));
      }
      setPrevScTime(requestData?.schedule_time);
      setSelectedTime(requestData?.schedule_time);
    }
  }, [requestData]);

  useEffect(() => {
    const handler = setTimeout(async () => {

      if (descVal !== '' && requestData?.id) {
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests/" + requestData?.id, { description: descVal }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }).then((response) => {

          setRequestData(prev => {
            return { ...prev, description: response.data.data?.description };
          });


        }).catch(() => { });
      }
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [descVal, getAccessTokenSilently]);

  const deleteConfirm = async () => {
    setOpenDeleteModal(false);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.delete(process.env.REACT_APP_CASE_API_URL + 'v1/maintenance-requests/' + requestData?.id + '/files/' + deleteId, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(response => {
      setRequestData(prev => {
        if (deleteType === 1) {
          let images = prev?.resolve_images?.filter(i => i?.id !== deleteId);
          return { ...prev, resolve_images: images };
        } else {
          let images = prev?.images?.filter(i => i?.id !== deleteId);
          return { ...prev, images: images };
        }
      });

      let logData = {
        'title': 'Maintenance request image deleted',
        'description': [
          'Name: ' + requestData?.title,
          'Request number: ' + requestData?.request_no,
          'Property: ' + requestData?.property_name,
          'Apartment: ' + requestData?.apt_name,
          'Tenant: ' + requestData?.tenant_name,
        ]
      }
      AddLogCallAPI(logData, token);
    }).catch(error => { });
  }

  const fileHandler = async (e) => {
    let extErr = false;
    let sizeErr = false;
    let files = e.target.files;
    let allowedExtensionArr = ".jpg,.png,.jpeg,.svg,.doc,.docx,.xls,.xlsx,.pdf".split(',');

    if (files.length > 0) {
      if (allowedExtensionArr.length > 0) {
        let fileName = files[0].name;
        let fileSize = files[0].size;
        let fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
        fileNameExt = '.' + fileNameExt;

        if (allowedExtensionArr.indexOf(fileNameExt) === -1) {
          extErr = true;
        }

        if (fileSize >= 5242880) {
          sizeErr = true;
        }
      }
    }

    if (extErr) {
      toast.error("File type is not allowed.");
      return false;
    }

    if (sizeErr) {
      toast.error("File size should not be greater than 5 MB.");
      return false;
    }

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    setLoading(true);

    let formData = new FormData();
    formData.append("image", files[0]);

    axios.post(process.env.REACT_APP_CASE_API_URL + 'v1/maintenance-requests/' + requestData?.id + '/files/upload', formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then(response => {
      setLoading(false);

      setRequestData(prev => {
        let images = response.data.data.concat(prev?.images);
        return { ...prev, images: images };
      });

      let logData = {
        'title': 'Maintenance request image uploaded',
        'description': [
          'Name: ' + requestData?.title,
          'Request number: ' + requestData?.request_no,
          'Property: ' + requestData?.property_name,
          'Apartment: ' + requestData?.apt_name,
          'Tenant: ' + requestData?.tenant_name,
        ]
      }
      AddLogCallAPI(logData, token);

    }).catch(error => {
      setLoading(false);
    });
  }

  const assignTechnician = async () => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests-assign/" + requestData?.id, { technician_id: selectedTechnician }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setLoading(false);

      setRequestData(prev => {
        return { ...prev, technician_id: response.data.data.technician_id, technician_name: response.data.data.technician_name };
      });

      let logData = {
        title: "A technician has been assigned to request",
        description: [
          "Name: " + response.data.data.title,
          "Request number: " + response.data.data.request_no,
          "Apt No: " + response.data.data.property_name + " - " + response.data.data.apt_name,
          "Tenant: " + response.data.data.tenant_name,
          "Technician: " + response.data.data.technician_name,
        ],
      };
      AddLogCallAPI(logData, token);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const scheduleDateTime = async () => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests-schedule/" + requestData?.id, { schedule_date: dayjs(selectedDate).format('YYYY-MM-DD'), schedule_time: selectedTime }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setLoading(false);

      setRequestData(prev => {
        return { ...prev, schedule_date: response.data.data.schedule_date, schedule_time: response.data.data.schedule_time, current_status: 2 };
      });

      if (response.data.data.schedule_date) {
        setPrevScDate(dayjs(response.data.data.schedule_date));
        setSelectedDate(dayjs(response.data.data.schedule_date));
      }
      setPrevScTime(response.data.data.schedule_time);
      setSelectedTime(response.data.data.schedule_time);

      let logData = {
        title: "A maintenant request has been scheduled.",
        description: [
          "Name: " + response.data.data.title,
          "Request number: " + response.data.data.request_no,
          "Apt No: " + response.data.data.property_name + " - " + response.data.data.apt_name,
          "Tenant: " + response.data.data.tenant_name,
          "Technician: " + response.data.data.technician_name,
          "Date/Time: " + dayjs(response.data.data.schedule_date).format('MM/DD/YYYY') + " - " + response.data.data.schedule_time,
        ],
      };
      AddLogCallAPI(logData, token);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const rescheduleDateTime = async () => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests-reschedule/" + requestData?.id, { schedule_date: dayjs(selectedDate).format('YYYY-MM-DD'), schedule_time: selectedTime }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setLoading(false);

      setRequestData(prev => {
        return { ...prev, schedule_date: response.data.data.schedule_date, schedule_time: response.data.data.schedule_time, current_status: 2 };
      });

      if (response.data.data.schedule_date) {
        setPrevScDate(dayjs(response.data.data.schedule_date));
        setSelectedDate(dayjs(response.data.data.schedule_date));
      }
      setPrevScTime(response.data.data.schedule_time);
      setSelectedTime(response.data.data.schedule_time);
      setIsReschedule(false);

      let logData = {
        title: "A maintenant request has been scheduled.",
        description: [
          "Name: " + response.data.data.title,
          "Request number: " + response.data.data.request_no,
          "Apt No: " + response.data.data.property_name + " - " + response.data.data.apt_name,
          "Tenant: " + response.data.data.tenant_name,
          "Technician: " + response.data.data.technician_name,
          "Date/Time: " + dayjs(response.data.data.schedule_date).format('MM/DD/YYYY') + " - " + response.data.data.schedule_time,
        ],
      };
      AddLogCallAPI(logData, token);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  return (
    <>
      <div className={`${styles.AccordionList}`}>
        <div className={`${styles.AccordionListHead} ${isPanelOpen ? styles.Open : ""}`} onClick={() => onToggle("two")}>
          <p className={`${styles.Title}`}>Request</p>
          <img src="/static/img/downTriangle.svg" alt="" />
        </div>
        <div className={`${styles.AccordionListBody} ${isPanelOpen ? styles.Open : ""}`}>
          <div className={`${styles.AccouFormGroup}`}>
            <form>
              <div className={`${styles.ReqAddRow}`}>
                <div className={`${styles.ReqAddFormSec}`}>
                  <div className={`${styles.FormSec}`}>
                    {isAuthenticated && <>
                      <div className={`${styles.FormGroupFull} FormGroup`}>
                        <p className={`${styles.FilterLabel}`}>Technician Selection</p>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">Select Technician *</InputLabel>
                          <Select
                            label="Select Technician *"
                            value={selectedTechnician ? selectedTechnician : ''}
                            onChange={(e) => {
                              setSelectedTechnician(e.target.value);
                            }}
                            disabled={!(user["https://propertydek.com/permissions"].indexOf("request:assign-technician") > -1) || requestData?.current_status === 3 || requestData?.current_status === 4}
                          >
                            {technicianList?.map(i => {
                              return <MenuItem value={i?.value}>{i?.label}</MenuItem>
                            })}
                          </Select>
                        </FormControl>
                        {(selectedTechnician > 0 && prevTechnician !== selectedTechnician) && <button type='button' className={`${styles.SummaryUpdateBU}`} onClick={(e) => assignTechnician()}>Assign</button>}
                      </div>
                      {requestData?.current_status > 0 && <>
                        <div className={`${styles.FormGroupFull} FormGroup`}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label="Schedule Date *"
                              value={selectedDate}
                              onChange={(e) => {
                                setSelectedDate(e);
                              }}
                              renderInput={(params) => (
                                <TextField {...params} />
                              )}
                              disablePast
                              disabled={!(user["https://propertydek.com/permissions"].indexOf("request:schedule") > -1) || (requestData?.current_status > 1 && !isReschedule)}
                            />
                          </LocalizationProvider>
                        </div>
                        <div className={`${styles.FormGroupFull} FormGroup`}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Select Time *</InputLabel>
                            <Select
                              label="Select Time *"
                              value={selectedTime}
                              onChange={(e) => {
                                setSelectedTime(e.target.value);
                              }}
                              disabled={!(user["https://propertydek.com/permissions"].indexOf("request:schedule") > -1) || (requestData?.current_status > 1 && !isReschedule)}
                            >
                              <MenuItem value={"Morning (9AM - 12PM)"}>Morning (9AM - 12PM)</MenuItem>
                              <MenuItem value={"Afternoon (12PM - 3PM)"}>Afternoon (12PM - 3PM)</MenuItem>
                              <MenuItem value={"Evening (3PM - 6PM)"}>Evening (3PM - 6PM)</MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                        {user["https://propertydek.com/permissions"].indexOf("request:schedule") > -1 && <>
                          {(selectedDate && selectedTime && (dayjs(prevScDate).format('YYYY-MM-DD') !== dayjs(selectedDate).format('YYYY-MM-DD') || prevScTime !== selectedTime)) && <button type='button' className={`${styles.SummaryUpdateBU}`} onClick={(e) => isReschedule ? rescheduleDateTime() : scheduleDateTime()}>Save</button>}
                          {!isReschedule && requestData?.current_status === 2 && <button className={`${styles.AppoResBU}`} onClick={(e) => setIsReschedule(true)}>Reschedule Appointment</button>}
                        </>}
                      </>}
                    </>}
                    <div className={`${styles.FormGroupFull} FormGroup`}>
                      <label className={`${styles.FilterLabel}`}>Describe the Maintenance Issue</label>
                      <TextField id="outlined-multiline-static" label="Add Description*" multiline rows={6} value={descVal} disabled={!(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request:update") > -1)}
                        onChange={(e) => {
                          setDescVal(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                  <div className={`${styles.FormIMGSec} ${styles.FileUploadSmall}`}>
                    <label className={`${styles.FilterLabel}`}>Share a Documents/Photos</label>
                    <div className={`${styles.FileIMGDiv}`}>
                      {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request:update") > -1) && <div className={`${styles.FileUpDuBUDiv}`}>
                        {/* <label for="file-upload" className={`${styles.UploadLabel}`}>
                          <UploadCloud />
                          <p>Upload Documents/Photos</p>
                        </label> */}
                        {requestData?.images?.length === 0 && (<label className={`${styles.TakePhoteBU}`} for="file-upload"><UploadCloud /> Upload Documents/Photos</label>)}
                        <input id="file-upload" type="file" onChange={fileHandler} accept={".jpg,.png,.jpeg,.svg,.doc,.docx,.xls,.xlsx,.pdf"} />
                        {requestData?.images?.length === 0 && (<p className={`${styles.UploadText}`}>File size upto 10 MB. JPG, PNG, PDF, DOC, XLX file only</p>)}
                      </div>}

                      <div className={`${styles.UpIMGSec}`}>
                        {requestData?.images?.map((item, index) => {
                          return (<div className={`${styles.ImgFile}`}>
                            {((item?.file_path.split('.').pop() === 'doc' || item?.file_path.split('.').pop() === 'docx') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                              <img src="/static/img/docIcon.png" alt="" />
                              <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                            </a> : ((item?.file_path.split('.').pop() === 'xls' || item?.file_path.split('.').pop() === 'xlsx') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                              <img src="/static/img/excelIcon.png" alt="" />
                              <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                            </a> : ((item?.file_path.split('.').pop() === 'pdf') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                              <img src="/static/img/pdfIcon.png" alt="" />
                              <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                            </a> : <img src={item?.file_public_url} className={styles.UpIMG} alt="" />)))}
                            {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request:update") > -1) && <Button onClick={(e) => { setOpenDeleteModal(true); setDeleteId(item?.id); setDeleteType(0); }}> <X /> </Button>}
                          </div>)
                        })}
                        {requestData?.images?.length > 0 && (<label className={`${styles.TakePhoteSQRBU}`} for="file-upload"><Plus /></label>)}
                        {requestData?.images?.length === 0 && (
                          <div className={`${styles.NoImgDiv}`}>
                            <img src="/static/img/no-photo.png" alt="" />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          {/* <p className={`${styles.SummaryDetails}`}>pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim.</p>
          <div className={`${styles.ReqDeAddBodyFile}`}>
              <p className={`${styles.FileTitle}`}>Images</p>
              <div className={`${styles.AddFormFileUP}`}>
                <img src="/static/img/ApartmentBedRoom.jpg" className={`${styles.UpIMG}`} />
              </div>
          </div> */}
          {/*!isResolveOpen && <button className={`${styles.ResolveBU}`} onClick={(e) => openResolve()}>Resolve</button>*/}
        </div>
      </div>

      <Dialog
        open={openDeleteModal}
        fullWidth
        maxWidth="sm"
        onClose={(e) => setOpenDeleteModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp"
      >
        <DialogTitle id="alert-dialog-title">Are you sure you want to delete the image?<button onClick={(e) => setOpenDeleteModal(false)}><X /></button></DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className="ModalFormGroup">
              <label className="PopupBodyText">The image will be removed immediately.You can't undo this action.</label>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="CancelPopupBU" onClick={(e) => deleteConfirm()}>Delete</Button>
          <Button className="SubmitPopupBU" onClick={(e) => setOpenDeleteModal(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default RequestMobile;
